import {HttpServices} from '../Helpers';
import {PHP_V13_URL} from '../api/urls';

export const GetEmployeePersonalData = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/view?uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeJobExperience = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/job-experience?employee_uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeEducation = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/education?employee_uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeAcademicSkills = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/setup/${
            process.env.REACT_APP_VERSION_API
        }/personnel/academic-skill?uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
